import React from "react";
import { Link } from "react-router-dom";
import PageHeader from "../components/PageHeader";

/**
 * Innovazione shows a single big card for TIME Watch. Clicking it opens the
 * existing TIME Watch (unchanged) at /innovazione/time-watch.
 * The image is only used to represent the product visually.
 */
export default function InnovazionePage() {
  return (
    <div className="px-5 sm:px-8 lg:px-12 py-16 sm:py-20 max-w-6xl mx-auto">
      <PageHeader
        eyebrow="Innovazione"
        title="Strumenti nuovi per comprendere il Tempo."
        description="La sezione dedicata alle innovazioni dell'ecosistema TIME."
        testId="innovazione-header"
      />

      <div
        data-testid="innovazione-grid"
        className="grid grid-cols-2 gap-3 sm:gap-8 max-w-3xl"
      >
        <Link
          to="/innovazione/time-watch"
          data-testid="cover-time-watch"
          className="group block"
        >
          <div className="relative aspect-square rounded-xl overflow-hidden bg-white/[0.02] border border-white/5 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.6)] transition-all duration-500 group-hover:-translate-y-2 group-hover:shadow-[0_25px_60px_-15px_rgba(16,185,129,0.35)] group-hover:border-emerald-400/25">
            <img
              src="/images/time-watch.png"
              alt="TIME Watch"
              loading="lazy"
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
          </div>
          <div className="mt-4 px-1">
            <div className="text-sm sm:text-base font-light text-white leading-snug tracking-tight group-hover:text-emerald-200 transition-colors">
              TIME Watch
            </div>
            <div className="mt-1 text-[11px] font-light text-white/40 leading-relaxed line-clamp-2">
              Il tuo tempo, letto come denaro
            </div>
          </div>
        </Link>

        {/* TIME Bracelet — prodotto in sviluppo, nessuna interazione */}
        <div
          data-testid="cover-time-bracelet"
          aria-label="TIME Bracelet — In sviluppo"
          className="block cursor-default select-none"
        >
          <div className="relative aspect-square rounded-xl overflow-hidden bg-white/[0.02] border border-white/5 shadow-[0_10px_40px_-15px_rgba(0,0,0,0.6)]">
            <img
              src="/images/time-bracelet.png"
              alt="TIME Bracelet"
              loading="lazy"
              draggable={false}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" />
            <div
              data-testid="time-bracelet-badge"
              className="absolute top-3 right-3 inline-flex items-center px-2.5 py-1 rounded-full backdrop-blur-md bg-black/50 border border-white/15 text-[9px] tracking-[0.28em] uppercase text-white/80 font-mono"
            >
              In sviluppo
            </div>
          </div>
          <div className="mt-4 px-1">
            <div
              data-testid="time-bracelet-title"
              className="text-sm sm:text-base font-light text-white leading-snug tracking-tight"
            >
              TIME Bracelet
            </div>
            <div
              data-testid="time-bracelet-desc"
              className="mt-1 text-[11px] font-light text-white/40 leading-relaxed line-clamp-2"
            >
              Prodotto innovativo in fase di sviluppo.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
